import React, { useState } from 'react';
import '../styles/Pages.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your message. We will get back to you soon!');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <main className="page-content">
      <section className="page-header">
        <h1>Connect With Us</h1>
      </section>
      <section className="page-body">
        <div className="contact-section">
          <h2>Get in Touch</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary">Send Message</button>
          </form>
        </div>

        <div className="social-section">
          <h2>Follow Us On Social Media</h2>
          <div className="social-links">
            <a href="https://x.com/iHariPrabodham" target="_blank" rel="noopener noreferrer" className="social-link">Twitter</a>
            <a href="https://www.instagram.com/ihariprabodham/" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
            <a href="https://www.facebook.com/ihariprabodham/" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
            <a href="https://www.youtube.com/@iHariPrabodham" target="_blank" rel="noopener noreferrer" className="social-link">YouTube</a>
          </div>
        </div>

        <div className="apps-section">
          <h2>Download Our Apps</h2>
          <div className="app-links">
            <h3>Android Apps</h3>
            <ul>
              <li><a href="https://play.google.com/store/apps/details?id=org.hariprabodham.ihariprabodham" target="_blank" rel="noopener noreferrer">iHariPrabodham App</a></li>
              <li><a href="https://play.google.com/store/apps/details?id=com.hari.patrika.patrika" target="_blank" rel="noopener noreferrer">HariPrabodham App</a></li>
              <li><a href="https://play.google.com/store/apps/details?id=org.hariprabodham.swaminivato" target="_blank" rel="noopener noreferrer">Paramrut App</a></li>
              <li><a href="https://play.google.com/store/apps/details?id=org.hariprabodham.kirtan" target="_blank" rel="noopener noreferrer">Hari Kirtan App</a></li>
            </ul>
            
            <h3>iOS Apps</h3>
            <ul>
              <li><a href="https://apps.apple.com/in/app/hariprabodham/id6443796461" target="_blank" rel="noopener noreferrer">HariPrabodham App</a></li>
              <li><a href="https://apps.apple.com/in/app/paramrut/id6451111413" target="_blank" rel="noopener noreferrer">Paramrut App</a></li>
              <li><a href="https://apps.apple.com/in/app/hari-kirtan/id1664675926" target="_blank" rel="noopener noreferrer">Hari Kirtan App</a></li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
